import { EnvironmentProviders, Provider } from '@angular/core';
import { FP_LOGGER_NOISE_TAB_CONNECT_SERVICES } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/providers/fp-logger-noise-tab-connect-services.token';
import { FpLoggerNoiseSummaryConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-summary/services/fp-logger-noise-summary-connect.service';
import { FpLoggerNoiseSummaryStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-summary/services/fp-logger-noise-summary/fp-logger-noise-summary.store';

export function fpLoggerNoiseSummaryProvider(): (EnvironmentProviders | Provider)[] {
  return [
    FpLoggerNoiseSummaryStore,
    FpLoggerNoiseSummaryConnectService,
    {
      provide: FP_LOGGER_NOISE_TAB_CONNECT_SERVICES,
      useExisting: FpLoggerNoiseSummaryConnectService,
      multi: true,
    },
  ];
}
